module.exports = new __parcel__URL__("incidents-task-two-illustration-dark.8b5496cd.png").toString();